export default __webpack_public_path__ + "static/iphone-mockup@3x-52784a1c3964c59f83d5c6cc5fe5eced.png";